// extracted by mini-css-extract-plugin
module.exports =  {"linkContent":"linkContent__-wRTX"};